import styled, { css } from 'styled-components';

const carouselBackgroundStyles = css`
  .styles-container {
    position: relative;
  }

  .crossfade-image {
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      position: absolute !important;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }
`;

const SectionContainer = styled.div`
  ${({ $carousel }) => $carousel && carouselBackgroundStyles}
  position: relative;
  padding: 30px;
  border: 1px solid var(--grey-2);
  border-radius: 4px;
  height: 100%;

  > h4 {
    color: var(--titan-blue-3);
    margin-bottom: 20px;
  }
  > a.nolink {
    cursor: default;
  }
  > a:not(.nolink) > div {
    display: flex;
    justify-content: space-between;
    width: 100%;
    ul {
      margin-top: 15px;
      padding-left: 25px;
      li {
        margin-top: 15px;
      }
    }
    svg {
      fill: var(--grey-3);
    }
    &:hover {
      > p {
        color: var(--titan-blue-3);
      }
      svg {
        fill: var(--titan-blue-3);
      }
    }
  }

  &.active {
    animation: borderAnimation 3s forwards;
  }

  @keyframes borderAnimation {
    0% {
      border: 1px solid transparent;
    }
    50% {
      border: 1px solid var(--titan-blue-3);
    }
    100% {
      border: 1px solid var(--grey-2);
    }
  }
`;

const CarouselContainer = styled.div`
  .carousel--heading {
    margin: 0 0 60px 0 !important;
  }

  @media (min-width: 576px) {
    > div:first-of-type {
      overflow-x: hidden;
    }
  }
`;

export { CarouselContainer, SectionContainer };
